import { render } from "./ChooseBeds.vue?vue&type=template&id=cd718bda&scoped=true"
import script from "./ChooseBeds.vue?vue&type=script&lang=js"
export * from "./ChooseBeds.vue?vue&type=script&lang=js"

import "./ChooseBeds.vue?vue&type=style&index=0&id=cd718bda&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd718bda"]])

export default __exports__